import myConfig from "../configs/config";

let drawingLibraryPromise = null;

function getMapsNamespace() {
  return window.google && window.google.maps ? window.google.maps : null;
}

export function isDrawingLibraryReady(maps) {
  const api = maps || getMapsNamespace();
  return Boolean(api && api.drawing && api.drawing.DrawingManager);
}

export function isGeometryLibraryReady(maps) {
  const api = maps || getMapsNamespace();
  return Boolean(api && api.geometry && api.geometry.spherical);
}

export async function ensureDrawingLibraries(maps) {
  const api = maps || getMapsNamespace();
  if (!api) {
    throw new Error("Google Maps API is not loaded");
  }

  if (isDrawingLibraryReady(api) && isGeometryLibraryReady(api)) {
    return api;
  }

  if (typeof api.importLibrary === "function") {
    if (!drawingLibraryPromise) {
      drawingLibraryPromise = Promise.all([
        isDrawingLibraryReady(api) ? Promise.resolve() : api.importLibrary("drawing"),
        isGeometryLibraryReady(api) ? Promise.resolve() : api.importLibrary("geometry"),
      ]).then(() => api);
    }
    return drawingLibraryPromise;
  }

  if (!isDrawingLibraryReady(api)) {
    throw new Error("Drawing library is not available");
  }

  return api;
}

export async function loadGoogleMapsWithDrawingLibraries() {
  const existing = getMapsNamespace();
  if (existing) {
    return ensureDrawingLibraries(existing);
  }

  if (!drawingLibraryPromise) {
    drawingLibraryPromise = new Promise((resolve, reject) => {
      const callbackName = "_agriFarmMapGoogleInit";
      window[callbackName] = async function initGoogleMapsForFarmDrawing() {
        delete window[callbackName];
        try {
          const maps = await ensureDrawingLibraries(getMapsNamespace());
          resolve(maps);
        } catch (error) {
          reject(error);
        }
      };

      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        myConfig.GOOGLE_API_KEY +
        "&libraries=drawing,geometry&callback=" +
        callbackName;
      script.async = true;
      script.defer = true;
      script.onerror = function onGoogleMapsScriptError() {
        reject(new Error("Failed to load Google Maps script"));
      };
      document.head.appendChild(script);
    });
  }

  return drawingLibraryPromise;
}

export function resetDrawingLibraryCache() {
  drawingLibraryPromise = null;
}
